'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _odataFilterBuilder = require('odata-filter-builder');

var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);

var _query = require('utilities/query');

var _messages = require('common/messages');

var _company = require('./company.html');

var _company2 = _interopRequireDefault(_company);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _company2.default,
  bindings: {
    accessLevels: '<',
    company: '<',
    user: '<'
  },
  controller: function () {
    function CompanyComponent($mdDialog, $scope, $state, AccountService, ArrayService, CompanyService, AuthService, PeopleService, ToastService) {
      'ngInject';

      _classCallCheck(this, CompanyComponent);

      Object.assign(this, {
        $mdDialog: $mdDialog,
        $scope: $scope,
        $state: $state,
        AccountService: AccountService,
        ArrayService: ArrayService,
        CompanyService: CompanyService,
        AuthService: AuthService,
        PeopleService: PeopleService,
        ToastService: ToastService
      });
    }

    _createClass(CompanyComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.selectedUsers = [];

        this.query = _extends({}, this.PeopleService.getDefaultQuery());

        this.refreshResults();
      }
    }, {
      key: 'userAdd',
      value: function userAdd() {
        var _this = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          accessLevels: this.accessLevels,
          onUserChanged: function onUserChanged($event) {
            return _this.onUserAdded($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <user-add-form\n                require-user-type-selection="false"\n                access-levels="accessLevels"\n                on-user-changed="onUserChanged($event)">\n              </user-add-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onUserAdded',
      value: function onUserAdded(_ref) {
        var _this2 = this;

        var user = _ref.user;

        if (user) {
          this.AccountService.addAccount(_extends({}, user, {
            TypeReferenceId: this.company.MemberId,
            UserTypeId: 1
          })).then(function () {
            _this2.ToastService.showSuccess(_messages.USER_ADDED);
            _this2.$mdDialog.hide();
            _this2.refreshResults();
          }).catch(function (error) {
            return _this2.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'userEdit',
      value: function userEdit(user) {
        var _this3 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          accessLevels: this.accessLevels,
          user: _angular2.default.copy(user),
          onUserChanged: function onUserChanged($event) {
            return _this3.onUserEdited($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <user-edit-form\n                user="user"\n                access-levels="accessLevels"\n                show-access-level="true"\n                on-user-changed="onUserChanged($event)">\n              </user-edit-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onUserEdited',
      value: function onUserEdited(_ref2) {
        var _this4 = this;

        var user = _ref2.user;

        if (user) {
          this.AccountService.updateAccount(user).then(function () {
            _this4.ToastService.showSuccess(_messages.USER_EDITED);
            _this4.$mdDialog.hide();
            _this4.refreshResults();
          }).catch(function (error) {
            return _this4.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'userDelete',
      value: function userDelete(users) {
        var _this5 = this;

        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected user(s) cannot be recovered!').ok('Delete').cancel('Cancel');

        this.$mdDialog.show(confirm).then(function () {
          var promises = [];
          for (var i = users.length - 1; i >= 0; i -= 1) {
            promises.push(_this5.AccountService.deleteAccount(users[i].UserId));
          }

          Promise.all(promises).then(function () {
            _this5.ToastService.showSuccess(_messages.USER_DELETED);
            _this5.refreshResults();
          }).catch(function (error) {
            return _this5.ToastService.showError(error);
          });
        });
      }
    }, {
      key: 'updateCompany',
      value: function updateCompany(_ref3) {
        var _this6 = this;

        var company = _ref3.company;

        if (company) {
          this.CompanyService.update(company).then(function () {
            _this6.ToastService.showSuccess(_messages.ACCOUNT_EDITED);
            _this6.$state.reload();
          }).catch(function (error) {
            return _this6.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'updateAccount',
      value: function updateAccount(_ref4) {
        var _this7 = this;

        var user = _ref4.user;

        if (user) {
          this.AccountService.updateAccount(user).then(function () {
            _this7.ToastService.showSuccess(_messages.ACCOUNT_EDITED);
            _this7.$state.reload();
          }).catch(function (error) {
            return _this7.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'showChangePassword',
      value: function showChangePassword(user) {
        var _this8 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          passwordChanged: function passwordChanged($event) {
            return _this8.onPasswordChanged($event);
          },
          credentials: {
            UserId: user.UserId
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <change-password\n                password-changed="passwordChanged($event)"\n                require-current-password="false"\n                credentials="credentials">\n              </change-password>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onPasswordChanged',
      value: function onPasswordChanged(_ref5) {
        var _this9 = this;

        var credentials = _ref5.credentials;

        if (credentials) {
          this.AccountService.forcePasswordChange(_extends({}, credentials)).then(function () {
            _this9.$mdDialog.hide();
            _this9.ToastService.showSuccess(_messages.PASSWORD_CHANGED);
            _this9.selectedUsers = [];
          }).catch(function (error) {
            return _this9.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'setUserLockout',
      value: function setUserLockout(_ref6) {
        var _this10 = this;

        var userId = _ref6.userId,
            isLocked = _ref6.isLocked;

        this.AccountService.setLockoutStatus(userId, isLocked).then(function () {
          _this10.ToastService.showSuccess(_messages.ACCOUNT_LOCKOUT_EDITED);
        }).catch(function (error) {
          return _this10.ToastService.showError(error);
        });
      }
    }, {
      key: 'onSearchTextChanged',
      value: function onSearchTextChanged(_ref7) {
        var searchText = _ref7.searchText;

        this.searchText = searchText;
        this.refreshResults();
      }
    }, {
      key: 'onQueryChanged',
      value: function onQueryChanged(_ref8) {
        var query = _ref8.query;

        this.query = query;
        this.refreshResults();
      }
    }, {
      key: 'refreshResults',
      value: function refreshResults() {
        var _this11 = this;

        this.selectedUsers = [];
        var filter = (0, _odataFilterBuilder2.default)();

        if (this.searchText && this.searchText.length) {
          filter = filter.contains('LastName', this.searchText).or(function (x) {
            return x.contains('FirstName', _this11.searchText);
          });
        }

        filter = filter.and(function (x) {
          return x.eq('UserTypeName', 'Member');
        }).and(function (x) {
          return x.ne('UserId', _this11.user.UserId);
        }).and(function (x) {
          return x.eq('TypeReferenceId', _this11.$state.params.id);
        });

        this.promise = this.PeopleService.search(_extends({}, this.query, {
          filter: filter
        }));

        this.promise.then(function (r) {
          _this11.users = (0, _query.transformODataResponse)(r);
        }).catch(function (error) {
          return _this11.ToastService.showError(error);
        });
      }
    }]);

    return CompanyComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/company/company.component.js